<template>
  <BlBackdrop
    title="Edit role"
    description="By changing the role, it will impact their access level within Blüm."
    label="Update"
    :submitLoading="submitLoading"
    :disabled="isDisabledSubmit"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onSubmit"
  >
    <div class="flex flex-col gap-3 px-8">
      <BlInputText :input="nameInput" />
      <BlInputText :input="emailInput" />
      <BlSelectBox
        label="Role"
        asterisk
        v-model="roleInput"
        placeholder="Select role"
        :options="roleOptions"
        @change="roleInput = $event"
      />
      <BlTextBody2
        v-if="!isDisabledSubmit"
        text="Are you sure you want to proceed with this role change?"
      />
    </div>
  </BlBackdrop>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BlBackdrop from "../BlBackdrop.vue";
import BlTextBody2 from "../BlTextBody2.vue";
import BlInputText from "../BlInputText.vue";
import BlSelectBox from "../BlSelectBox.vue";

export default {
  name: "EditUserRoleModal",
  components: {
    BlBackdrop,
    BlTextBody2,
    BlInputText,
    BlSelectBox
  },
  props: {
    user: { type: Object, required: true }
    // @close-modal
  },
  data() {
    return {
      submitLoading: false,
      userRoles: {
        admin: "Admin",
        staff: "Therapist",
        super_admin: "Super admin"
      },
      nameInput: {
        label: "Name",
        disabled: true,
        model: this.user.name
      },
      emailInput: {
        label: "Email",
        disabled: true,
        model: this.user.email
      },
      roleInput: this.user.role,
      roleOptions: [
        { value: "admin", label: "Admin" },
        { value: "staff", label: "Therapist" }
      ]
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
    isDisabledSubmit() {
      if (this.roleInput === this.user.role) return true;
      return false;
    }
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions(["updateUser"]),
    async onSubmit() {
      const params = {
        id: this.user.id,
        user: { role: this.roleInput },
        title: "Role changed",
        message: "Success! The role has been changed successfully."
      };

      this.submitLoading = true;
      const { success } = await this.updateUser(params);
      this.submitLoading = false;
      if (!success) return;
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/team/EditUserRoleModal.vue